import { gql } from "generated/gql"


export const GET_DOCUMENTS_QUERY = gql(`
  query GetDocuments($clientId: ID) {
    documents(clientId: $clientId) {
      ...DocumentFields
    }
  }
`)

export const UPDATE_CLIENT = gql(`
  mutation UpdateClient(
    $id: ID!,
    $createDocuments: [DocumentInput!]
    $updateDocuments: [DocumentUpdateInput!]
    $destroyDocuments: [ID!]
  ) {
    mutationResult:updateClient (input: {
      id: $id,
      createDocuments: $createDocuments,
      updateDocuments: $updateDocuments,
      destroyDocuments: $destroyDocuments,
    }) {
      id
      errors
      client {
        id
        documents {
          id
          name
          fileUrl
          description
          updatedAt
        }
      }
    }
  }
`)
